import { render, staticRenderFns } from "./AdminProdStatus.vue?vue&type=template&id=79a6cddc&scoped=true&"
import script from "./AdminProdStatus.vue?vue&type=script&lang=js&"
export * from "./AdminProdStatus.vue?vue&type=script&lang=js&"
import style0 from "./AdminProdStatus.vue?vue&type=style&index=0&id=79a6cddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a6cddc",
  null
  
)

export default component.exports